import { render, staticRenderFns } from "./KaartReunies.vue?vue&type=template&id=48c0eab2&scoped=true&"
import script from "./KaartReunies.vue?vue&type=script&lang=js&"
export * from "./KaartReunies.vue?vue&type=script&lang=js&"
import style0 from "./KaartReunies.vue?vue&type=style&index=0&id=48c0eab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c0eab2",
  null
  
)

export default component.exports